<template>
  <div v-if="switching">{{ text }}</div>
  <div v-else-if="!hasCookie">{{ text }}即将跳往登录页（{{ num }}）</div>
</template>
<script>
import { switchIdentity, loadUserInfo } from './login/servers'
export default {
  data() {
    return {
      text: '无供应链平台页面权限，请联系超级管理员！',
      num: 3,
      switching: false,
    }
  },
  computed: {
    hasCookie() {
      return this.$route.query.hasCookie === 'true'
    }
  },
  methods: {
    setup(cb) {
      setTimeout(() => {
        if (this.num < 1) {
          cb && cb();
          this.num = 3;
          return ;
        }
        this.num = this.num - 1
        this.setup(cb)
      }, 1000);
    },
    async switchIdentity(loginIdentity) {
      // 切换身份
      const success = await switchIdentity(loginIdentity);
      const success2 = await loadUserInfo()
      if (success && success2) {
        this.$router.replace(this.$store.state.user?.bindRelationUrl);
      }
    }
  },
  created() {
    const bindUrl = this.$store.state.user?.bindRelationUrl;
    const loginIdentity = this.$store.state.user.userInfo?.loginIdentity;
    let stopSetUp = false;
    if (/^\/distributor/.test(bindUrl) && Number(loginIdentity) === 1) {
      this.switching = true;
      stopSetUp = true;
      // 当前有分销商邀请链接且当前登录者是供销商
      this.text = '正在切换分销商身份，请稍后'
      this.switchIdentity(2);
    } else if (/^\/supplier/.test(bindUrl) && Number(loginIdentity) === 2) {
      this.switching = true;
      stopSetUp = true;
      // 当前有供销商商邀请链接且当前登录者是分销商
      this.text = '正在切换供销商身份，请稍后'
      this.switchIdentity(1);
    } else {
      if(location.href.includes('from-gyl')){
        setTimeout(() => {
          this.switching = true;
        }, 5000);
      }
      this.text = '无供应链平台页面权限，请联系超级管理员！'
    }
    if (!this.hasCookie && !stopSetUp) {
      this.setup(() => {
        this.$store.dispatch("LOGOUT");
      })
    }
  }
}
</script>
